import React, { createContext, useContext, useState, useEffect } from 'react';
import engTranslations from '../locales/eng.json';
import arTranslations from '../locales/ar.json';

const TranslationContext = createContext();

export const useTranslation = () => {
  const context = useContext(TranslationContext);
  if (!context) {
    throw new Error('useTranslation must be used within a TranslationProvider');
  }
  return context;
};

export const TranslationProvider = ({ children }) => {
  const [language, setLanguage] = useState('eng');
  const [translations, setTranslations] = useState(engTranslations);

  useEffect(() => {
    setTranslations(language === 'eng' ? engTranslations : arTranslations);
  }, [language]);

  const toggleLanguage = () => {
    setLanguage(prevLang => prevLang === 'eng' ? 'ar' : 'eng');
  };

  const t = (key) => {
    const keys = key.split('.');
    let value = translations;
    
    for (const k of keys) {
      if (value && typeof value === 'object' && k in value) {
        value = value[k];
      } else {
        console.warn(`Translation key "${key}" not found`);
        return key;
      }
    }
    
    return value;
  };

  const value = {
    language,
    setLanguage,
    toggleLanguage,
    t,
    isRTL: language === 'ar'
  };

  return (
    <TranslationContext.Provider value={value}>
      {children}
    </TranslationContext.Provider>
  );
};
